import React, { useState } from "react"
import { manageProfileName } from "../../../api/manage_profile_name"
import { useNavigate } from "react-router-dom"
import { useLoading } from "../../LoadingContext"

import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"

interface ManageUserNameProps {
  name: string
  onClose: (name: string) => void // モーダルを閉じるためのコールバック
}

const ManageUserName: React.FC<ManageUserNameProps> = ({ name, onClose }) => {
  const { startLoading, stopLoading } = useLoading()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: name
  })

  const [errors, setErrors] = useState({
    name: ""
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const target = e.target as HTMLInputElement // 明示的に型キャスト
    const { name, value, type, checked } = target
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }))
  }

  const validate = () => {
    const validationErrors = { ...errors }
    let hasError = false

    // 絵文字を除外するための正規表現
    const emojiRegex = /[\p{Extended_Pictographic}\uD83C-\uDBFF\uDC00-\uDFFF]+/gu

    // 必須項目のバリデーション
    if (!formData.name) {
      validationErrors.name = "必須項目が入力されていません"
      hasError = true
    } else if (formData.name.length > 12) {
      validationErrors.name = "名前は1文字以上12文字以下で入力してください"
      hasError = true
    } else if (emojiRegex.test(formData.name)) {
      validationErrors.name = "名前に絵文字は使用できません"
      hasError = true
    } else {
      validationErrors.name = ""
    }

    setErrors(validationErrors)
    return !hasError
  }

  const convertEnabledValues = (data: any) => {
    return data
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (validate()) {
      // バリデーション成功時の処理
      try {
        startLoading()
        const convertedData = convertEnabledValues(formData)
        await manageProfileName(convertedData.name)
        onClose(formData.name)
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          navigate("/login")
        } else if (error.response) {
          const errorDetail = error.response.data.detail
          const validationErrors = { ...errors }
          validationErrors.name = errorDetail.message
          setErrors(validationErrors)
        } else {
          const validationErrors = { ...errors }
          validationErrors.name = "サーバーへの接続に失敗しました"
          setErrors(validationErrors)
        }
      } finally {
        stopLoading()
      }
    }
  }

  return (
    <div className="modal-bg-cover">
      <Card
        sx={{
          width: "90%",
          maxWidth: "500px",
          maxHeight: "calc(100vh - 100px)",
          marginTop: "50px",
          marginBottom: "50px",
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: "20px"
        }}
      >
        <button className="close-button" onClick={() => onClose("")}>
          ×
        </button>
        <MDTypography variant="h4" fontWeight="medium">
          名前変更
        </MDTypography>
        <MDBox style={{ height: "20px" }}></MDBox>
        <MDBox
          style={{
            maxHeight: "calc(100vh - 200px)",
            overflowY: "auto",
            paddingTop: "10px",
            paddingLeft: "5px",
            paddingRight: "25px"
          }}
        >
          <MDBox display="flex" alignItems="center" gap={1}>
            <MDInput
              label="名前"
              name="name"
              value={formData.name}
              onChange={(e) => handleChange(e)}
              sx={{ width: "100%" }}
            />
          </MDBox>
          {errors.name && (
            <MDBox
              color="#FF0000" // テキスト色
              pl={2} // 左パディング
              mb={2} // 下マージン
              fontSize="0.7em" // フォントサイズ
            >
              {errors.name}
            </MDBox>
          )}
          <MDBox alignItems="center" mt={4} mb={2} sx={{ width: "100%", textAlign: "center" }}>
            <MDButton
              variant="contained"
              color="info"
              sx={{
                borderRadius: "4px",
                textTransform: "none",
                fontSize: "1rem",
                padding: "0.75rem 0",
                backgroundColor: "#1976d2",
                "&:hover": {
                  backgroundColor: "#1565c0"
                },
                width: "50%"
              }}
              onClick={(e) => {
                handleSubmit(e)
              }}
            >
              更新
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </div>
  )
}

export default ManageUserName
